import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const serviceApi = createApi({
  reducerPath: "serviceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "services/service-category",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  // Removed tagTypes to fix the error

  endpoints: (builder) => ({
    getServices: builder.query({
      query: (query = {}) => {
        const {
          sort,
          filter,
          page = 1,
          limit = 10,
          id,
          search,
          parentId,
        } = query;
        let url;
        if (id) {
          url = `/${id}?`;
        } else {
          url = "?";
        }

        if (page) {
          url += `page=${page}`;
        }
        if (parentId) {
          url += `&parentId=${parentId}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        if (filter) {
          url += `&${filter}`;
        }

        if (sort) {
          url += `&sort=${sort}`;
        }

        if (search) {
          url += `&search=${search}`;
        }


        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getServicesLevelTow: builder.query({
      query: (query = {}) => {
        const { sort, filter, page = 1, limit = 10, id, search } = query;
        let url = `level-two?`;

        if (page) {
          url += `page=${page}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        if (filter) {
          url += `&${filter}`;
        }

        if (sort) {
          url += `&sort=${sort}`;
        }

        if (search) {
          url += `&search=${search}`;
        }


        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetServicesQuery, useGetServicesLevelTowQuery } = serviceApi;
